import _ from "lodash";

export class Export {
    id?: number;
    type?: string;
    status?: number;
    filename?: string;
    error?: string;
    created_at?: string;
    updated_at?: string;

    constructor(data: any) {
        _.assign(this, data);
    }

    // Status constants
    static readonly STATUS = {
        PENDING: 0,
        PROCESSING: 1,
        SUCCESS: 2,
        ERROR: 3,
    };

    // Types d'export accessibles à tous les utilisateurs authentifiés : tout
    // type absent de cette liste est réservé aux administrateurs.
    // À garder aligné avec App\Models\Export\Export::PUBLIC_TYPES.
    static readonly PUBLIC_TYPES = [
        "journal_pdf",
        "avis_de_virement_pdf",
        "avis_de_virement_excel",
        "avis_de_prelevement_pdf",
        "avis_de_prelevement_excel",
        "disponibilites_excel",
        "disponibilites_calendrier_excel",
        "absences_non_assignees_excel",
        "trajets_excel",
        "planning_pdf",
    ];

    static requiresAdmin(type: string): boolean {
        return !Export.PUBLIC_TYPES.includes(type);
    }

    // Status label getter
    get status_label(): string {
        switch (this.status) {
            case Export.STATUS.PENDING:
                return "En attente";
            case Export.STATUS.PROCESSING:
                return "En cours de génération";
            case Export.STATUS.SUCCESS:
                return "Terminé";
            case Export.STATUS.ERROR:
                return "Erreur";
            default:
                return "Inconnu";
        }
    }
}
